import {createGlobalStyle, keyframes} from 'styled-components';
import {useFeatureToggles} from '../../../context';
import React from 'react';

const slideOut = keyframes`
    0% {
        transform: translateX(0%);
    }
    100% {
        opacity: 0;
        transform: translateX(calc(50%));
    }
`;

const slideIn = keyframes`
    0% {
        opacity: 0;
        transform: translateX(calc(-50%));
    }
    100% {
        transform: translateX(0%);
    }
`;

const GlobalTransitionStyle = createGlobalStyle`
    ::view-transition-group(topbar) {
    }
    ::view-transition-old(topbar) {
        animation: none;
    }
    ::view-transition-new(topbar) {
        animation: none;
    }

    ::view-transition-group(nbab) {
    }
    ::view-transition-old(nbab) {
        animation: none;
    }
    ::view-transition-new(nbab) {
        animation: none;
    }

    ::view-transition-old(main) {
        animation: ${slideOut} 0.5s cubic-bezier(0.86, 0, 0.07, 1) forwards;
    }
    ::view-transition-new(main) {
        animation: ${slideIn} 0.5s  cubic-bezier(0.86, 0, 0.07, 1) forwards;
    }

`;

export const ShowroomTransitionGlobalStyle = () => {
    const enabled = useFeatureToggles().showroomTopbarNavigationEnabled;

    if (!enabled) return null;

    return <GlobalTransitionStyle />;
};
